import { createFileRoute } from '@tanstack/react-router';

type Search = {
  view?: 'leadsContacted' | 'patientsScheduled' | 'revenueGenerated' | 'arConversion' | 'noShowRate';
};
/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/roi/no-show-rate')({
  validateSearch: (search: Search): Search => {
    return { view: search.view };
  },
});
